import styled from 'styled-components'

function ProgressBarVideo({ percentage }) {
    return (
        <ProgressBarContainer>
            <ProgressBar
                style={{
                    width: `calc(100% * ${0.01 * percentage})`
                }}
            ></ProgressBar>
            <ProgressPercentage>{`${percentage}%`}</ProgressPercentage>
        </ProgressBarContainer>
    )
}

const ProgressBarContainer = styled.div`
    width: 100%;
    max-width: 600px;
    padding: 10px;
    margin: 20px;
    background-color: #505183;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
`
const ProgressBar = styled.div`
    height: 20px;
    background-color: #2e2e53;
    border-radius: 5px;
`
const ProgressPercentage = styled.p`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #fff;
    width: 100%;
    max-width: 45px;
`

export default ProgressBarVideo
